import { useQuery } from '@tanstack/react-query';
import backend from '../../services/backend';
import { CurationVerdictRow } from './CurationVerdictRow';
import { FlagForCurationButton } from './FlagForCurationButton';

export function CurationCard({ pageId }: { pageId: string }) {
  const reviews = useQuery({
    queryKey: ['pageCurationReviews', pageId],
    queryFn: () => backend.getPageCurationReviews(pageId).then((res) => res.data),
    enabled: !!pageId,
  });

  const data = reviews.data;

  return (
    <div className="bg-white dark:bg-zinc-800 shadow dark:shadow-zinc-950/30 rounded-lg overflow-hidden">
      <div className="flex items-center justify-between gap-4 px-4 py-5 sm:p-6 border-b border-gray-200 dark:border-zinc-700">
        <h2 className="text-lg font-medium text-gray-900 dark:text-zinc-100">Curation</h2>
        <FlagForCurationButton
          pageId={pageId}
          pending={data?.hasPendingFlag ?? false}
          loading={reviews.isLoading}
        />
      </div>
      <div className="px-4 py-5 sm:p-6">
        {reviews.isLoading && <p className="text-sm text-gray-500 dark:text-zinc-400">Loading…</p>}
        {reviews.isError && (
          <p className="text-sm text-red-600 dark:text-red-400">Failed to load curation verdicts.</p>
        )}
        {data &&
          (data.verdicts.length === 0 ? (
            <p className="text-sm text-gray-500 dark:text-zinc-400">Not yet reviewed.</p>
          ) : (
            <>
              <div className="mb-4 flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-green-100 px-2.5 py-1 text-xs font-semibold text-green-800 dark:bg-green-900/40 dark:text-green-300">
                  {data.summary.agree} agree
                </span>
                <span className="rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-800 dark:bg-amber-900/40 dark:text-amber-300">
                  {data.summary.disagree} disagree
                </span>
                <span className="text-xs text-gray-500 dark:text-zinc-400">with current category</span>
              </div>
              <ul className="space-y-3">
                {data.verdicts.map((verdict) => (
                  <CurationVerdictRow key={verdict.id} verdict={verdict} />
                ))}
              </ul>
            </>
          ))}
      </div>
    </div>
  );
}
